import { fetchApi } from "../fetchApi";

export const onChangeProductMediaImage = async ({
  ids = [],
  product_id,
  product_name,
  context,
  company_id,
}) => {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [ids, ["id", "name", "image_1920", "sequence", "video_url"]],
      model: "product.image",
      method: "read",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],
          params: {
            cids: company_id,
            id: product_id,
            model: "product.template",
            view_type: "form",
          },
          search_default_published: 1,
          default_name: product_name,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  let response = await fetchApi({
    requestOptions,
    endpoint: "/web/dataset/call_kw/product.image/read",
  });
  response = JSON.parse(response);
  return response;
};
